import axios from 'axios';
import { MAPPING } from '../../helpers';
import { CONFIG } from '../../../../../environments';

const { endpoints } = MAPPING;

export const fetchOffers = (params) => axios.get(CONFIG.ENDPOINT.concat(endpoints?.getOffers), { params });
